import { render, staticRenderFns } from "./ConcernsCard.vue?vue&type=template&id=a5722caa&scoped=true&"
import script from "./ConcernsCard.vue?vue&type=script&lang=js&"
export * from "./ConcernsCard.vue?vue&type=script&lang=js&"
import style0 from "./ConcernsCard.vue?vue&type=style&index=0&id=a5722caa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5722caa",
  null
  
)

export default component.exports